import { useState, useEffect, useRef } from 'react';
import  {Stack, Dialog, DialogActions, DialogContent, DialogTitle, FormControl,
  Button, TextField, Select, MenuItem  } from '@mui/material';
import IconCancel from '@mui/icons-material/Cancel';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/en-gb';
import dataProvider from '../../lib/dataProvider';
import moment from 'moment';
import 'moment/dist/locale/de';

const EditPayment = ({open, close, paydata, setPaydata, addPayment}) => {

  const [paymenttypes, setPaymenttypes] = useState([]);
  const focusRef = useRef();

  useEffect(() => {
    dataProvider.getList('setPaymenttype', { filter: {   }, sort: false, pagination: { page: 1, perPage: 999 } })
      .then(response => { if (response.data) { setPaymenttypes(response.data);}
    });
  }, []);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        focusRef.current?.focus();
      }, 100);
    }
  }, [open]);  
  
  const updateData = (field) => (ev) => {
    setPaydata({...paydata, [field]: ev.target.value})
  }

  const addPay = () => {
    const pd = {...paydata};
    if (!pd.datum) pd.datum = moment();
    pd.datum = pd.datum.unix();
    pd.betrag = parseFloat(pd.betrag); 
    if (!pd.text) pd.text = 'Payment';
    if (!pd.id_zahlungsart) pd.id_zahlungsart = paymenttypes[0].id;
    pd.bezeichnung = paymenttypes.find(x=>x.id===pd.id_zahlungsart).bezeichnung;
    addPayment(pd);
    close();
  }

  if (paymenttypes.length<1) return null;

  return (
    <>
      <Dialog open={open} onClose={close}>
        <DialogActions style={{position:'absolute', right:0}}>
          <Button label="ra.action.cancel" onClick={close}><IconCancel /></Button>
        </DialogActions>
        <DialogTitle sx={{pb:1}}>Add Payment</DialogTitle>
        <DialogContent sx={{pb:1}}>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={'en-gb'}>
              <DateTimePicker
                views={['month', 'day', 'hours', 'minutes']}
                format="DD/MM/YYYY HH:mm"
                label="Date & Time"
                value={moment(paydata.datum)}
                onChange={(v) => setPaydata({...paydata, datum: v})}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>            
            <TextField label="Text" defaultValue="" onChange={updateData('text')} inputRef={focusRef} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{pb:1, '& > *':{flex:1}}}>
            <TextField label="Amount" value={paydata.betrag} onChange={updateData('betrag')} />
            <FormControl >
              <Select value={paydata.id_zahlungsart?paydata.id_zahlungsart:paymenttypes[0].id} onChange={updateData('id_zahlungsart')} style={{p:0}}>
                {paymenttypes.map((pt) => {
                  return (
                    <MenuItem key={pt.id} value={pt.id} style={{display:'grid', gridTemplateColumns: 'auto 10% 50%'}}>
                      {pt.bezeichnung}
                    </MenuItem>
                  )
                })}
              </Select>
            </FormControl>

          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={addPay}>Add Payment</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default EditPayment;